import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { scrollDashboardTabs } from '../utils/dashboardTabs';

const DashboardTabsArrow = ({ direction = 1, label }) => {
  const scrollDirection = Number(direction) < 0 ? -1 : 1;
  const isLeft = scrollDirection < 0;

  return (
    <button
      type="button"
      className="dashboard-tabs-arrow"
      onClick={(event) => scrollDashboardTabs(event, scrollDirection)}
      aria-label={label || `Scroll dashboard tabs ${isLeft ? 'left' : 'right'}`}
    >
      {isLeft ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
    </button>
  );
};

export default DashboardTabsArrow;
